import {selectUnits} from "../../../redux/reducers/sharedStateReducer/selectors";
import {checkIfSupplyRecruitHiddenFromViewer} from "../../unit/checkIfSupplyRecruitHiddenFromViewer";

/**
 * Какие новобранцы крысолюдов за снабжение только что встали на поле для этого клиента:
 * до итога фазы снабжения их видит лишь владелец (см.
 * checkIfSupplyRecruitHiddenFromViewer), а с итогом метка снимается. Владелец видел
 * проявление отряда еще при найме, поэтому в список не попадает.
 *
 * @param {Object} prevState — состояние прошлой перерисовки поля
 * @param {Object} state
 * @returns {Object[]} отряды из нового состояния
 */
export const resolveRevealedSupplyRecruits = (prevState, state) => {
  const prevUnits = selectUnits(prevState) || [];
  const units = selectUnits(state) || [];
  if (prevUnits === units) {
    return [];
  }

  const hiddenUnitIds = new Set(
    prevUnits.filter((unit) => checkIfSupplyRecruitHiddenFromViewer(unit, prevState)).map((unit) => unit.id)
  );
  return units.filter((unit) => hiddenUnitIds.has(unit.id) && !unit.isSupplyRecruit);
};
